var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "employees-card-bottom" }, [
        _c(
          "div",
          [
            _c(
              "oaFromBox",
              {
                attrs: {
                  title: "我的汇报",
                  isAddBtn: false,
                  search: _vm.search,
                  total: _vm.totalPage,
                  isViewSearch: false,
                },
                on: { confirmData: _vm.confirmData },
              },
              [
                _c(
                  "template",
                  { staticClass: "box", slot: "rightBtn" },
                  [
                    _c(
                      "el-dropdown",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { command: _vm.handleDaily },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["user:daily:my:add"],
                                expression: "['user:daily:my:add']",
                              },
                            ],
                            attrs: { type: "primary", size: "small" },
                          },
                          [_vm._v(_vm._s("填写汇报"))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          _vm._l(_vm.dailyData, function (item, index) {
                            return _c(
                              "el-dropdown-item",
                              { key: item.id, attrs: { command: item.id } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.name) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-popover",
                      { attrs: { placement: "bottom", trigger: "click" } },
                      [
                        _c(
                          "div",
                          { staticClass: "popoverWidth" },
                          [
                            _c("calendar", {
                              attrs: {
                                calendar: _vm.calendar,
                                tabType: _vm.tableFrom.type,
                              },
                              on: { switchTime: _vm.switchTime },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "btn",
                            attrs: { slot: "reference", type: "text" },
                            slot: "reference",
                          },
                          [_c("span", { staticClass: "iconfont icongengduo2" })]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "mt-10",
              },
              [
                _c(
                  "el-table",
                  {
                    ref: "elTable",
                    attrs: { data: _vm.tableData, height: _vm.tableHeight },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: _vm.$t("toptable.name"),
                        width: "90",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "frame_name",
                        label: _vm.$t("toptable.department"),
                        "min-width": "100",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "finish",
                        label: _vm.$t("toptable.worktoday"),
                        "min-width": "250",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return _vm._l(
                              scope.row.finish,
                              function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "textover3" },
                                  [_vm._v(_vm._s(item))]
                                )
                              }
                            )
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "plan",
                        label: _vm.$t("toptable.tomorrowplan"),
                        "min-width": "250",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.types != 3
                                ? _c(
                                    "div",
                                    _vm._l(
                                      scope.row.plan,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "textover3",
                                          },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("user.work.dailytype"),
                        width: "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.getDailyTypes(scope.row.types)) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "created_at",
                        label: _vm.$t("user.work.creationtime"),
                        width: "160",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("public.operation"),
                        "show-overflow-tooltip": true,
                        fixed: "right",
                        width: _vm.tableFrom.type == 0 ? 160 : 60,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["user:daily:my:check"],
                                      expression: "['user:daily:my:check']",
                                    },
                                  ],
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEdit(
                                        scope.row.daily_id,
                                        true,
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("public.check")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.tableFrom.type == 0 &&
                              new Date(scope.row.end_time).getTime() >
                                new Date().getTime()
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCheck(
                                            scope.row.daily_id,
                                            false,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("public.edit")) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tableFrom.type == 0 &&
                              new Date(scope.row.end_time).getTime() >
                                new Date().getTime()
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDelete(
                                            scope.row.daily_id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                删除\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-fixed" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "page-size": _vm.tableFrom.limit,
                        "current-page": _vm.tableFrom.page,
                        "page-sizes": [15, 20, 30],
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.totalPage,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("addBox", {
        ref: "addBox",
        attrs: {
          "edit-data": _vm.editData,
          "daily-id": _vm.dailyIndex,
          "edit-id": _vm.editId,
          needList: _vm.needList,
          finishList: _vm.finishList,
        },
        on: {
          tableList: _vm.tableList,
          updateValue: _vm.updateValue,
          getDailyTodoInfo: _vm.getDailyTodoInfo,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }